import { Link } from "react-router-dom";
import { filmInfo, posterImage } from "@/mocks/movie";

export default function FilmIntro() {
  return (
    <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[300px_1fr] lg:gap-12">
        <div className="relative mx-auto w-full max-w-[300px] overflow-hidden rounded-lg border border-background-800 lg:mx-0">
          <div className="h-[430px] w-full">
            <img
              src={posterImage}
              alt="《激情丛林》影片海报"
              title="激情丛林 电影海报"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>

        <div className="flex flex-col justify-center">
          <span className="mb-3 inline-flex items-center gap-2 font-label text-xs uppercase tracking-[0.25em] text-accent-500">
            <span className="h-px w-6 bg-accent-500/60"></span>
            关于这部影片
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
            一部关于敬畏的雨林寓言
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-300 md:text-base">
            《激情丛林》并不满足于讲述一次冒险。它用近乎纪实的笔触，把观众带进一片会呼吸的雨林，
            在泥泞与暴雨中追问人类向自然索取时那份失控的贪婪。它不提供廉价的胜利，
            只留下一个足够复杂的容器，让每个人都能装进自己的答案。
          </p>

          <dl className="mt-7 grid grid-cols-2 gap-x-6 gap-y-4 sm:grid-cols-3">
            {filmInfo.slice(2, 8).map((item) => (
              <div key={item.label}>
                <dt className="font-label text-xs uppercase tracking-widest text-foreground-500">
                  {item.label}
                </dt>
                <dd className="mt-1.5 text-sm font-medium text-foreground-100">{item.value}</dd>
              </div>
            ))}
          </dl>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/plot"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
            >
              <i className="ri-book-open-line"></i>
              阅读完整剧情
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-600 px-5 py-2.5 font-label text-sm text-foreground-100 transition-colors hover:border-accent-400 hover:text-accent-400"
            >
              <i className="ri-information-line"></i>
              影片资料
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}